import { render, staticRenderFns } from "./mobile_spot_resource_detail.vue?vue&type=template&id=f95e29a6&scoped=true&"
import script from "./mobile_spot_resource_detail.vue?vue&type=script&lang=js&"
export * from "./mobile_spot_resource_detail.vue?vue&type=script&lang=js&"
import style0 from "./mobile_spot_resource_detail.vue?vue&type=style&index=0&id=f95e29a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95e29a6",
  null
  
)

export default component.exports